import { NativeAppUnavailableException } from "../../../../Cryptography/Crypto/CryptoExceptions";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * @internal
 */
export class CryptoNativeAppUnavailableBuilder implements IContentBuilder {
    private readonly _exception: NativeAppUnavailableException;
    private _content: HTMLElement;

    constructor(exception: NativeAppUnavailableException) {
        this._exception = exception;
    }

    private async _buildMessageElement(): Promise<void> {
        const contentDiv = createElement({ classes: "crypto-component-unavailable-content" });

        const nativeAppMissingMessage = createElement({ type: "span", classes: "crypto-component-unavailable-message" });
        // "Pro podepisování musíte mít nainstalovanou aplikaci Crypto Native App. Aktuální verzi si můžete stáhnout na: "
        nativeAppMissingMessage.innerText = await Localization.getTextPromise("GUI-623881");
        contentDiv.appendChild(nativeAppMissingMessage);

        const nativeAppDownloadLink = createElement({
            type: "a",
            value: "Crypto Native App",
            attrs: { href: this._exception.downloadURL, target: "_blank" },
        });
        contentDiv.appendChild(nativeAppDownloadLink);

        this._content = contentDiv;
    }

    public async build(): Promise<HTMLElement> {
        await this._buildMessageElement();
        return this._content;
    }
}
